const iconCross = `
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
      <g fill="none" fill-rule="evenodd" transform="translate(1)">
        <path stroke="#ff0000" stroke-linecap="round" stroke-linejoin="round" d="M.208333333.208333333L9.79166667 9.79166667M9.79166667.208333333L.208333333 9.79166667"/>
        <rect width="10" height="10"/>
      </g>
    </svg>
`;

export default iconCross;
